import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackUserSession } from '@/lib/firebase';

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Tracker la visite de page
    trackPageView(location.pathname);
    
    // Tracker la session utilisateur
    trackUserSession();
    
    // Tracker le temps passé sur la page
    const startTime = Date.now();
    
    const handleBeforeUnload = () => {
      const timeSpent = Date.now() - startTime;
      // Vous pouvez envoyer le temps passé à Firebase Analytics
      console.log(`Temps passé sur ${location.pathname}: ${timeSpent}ms`);
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [location.pathname]);
}; 